var map = {
	"./check.svg": 6872,
	"./en.svg": 2785,
	"./logo-all.svg": 7543,
	"./logo-badge.svg": 5695,
	"./logo-full.svg": 7349,
	"./logo-inline.svg": 4617,
	"./logo-new.svg": 9928,
	"./logo.png": 4010,
	"./logo.svg": 5429,
	"./nb.svg": 4008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;